import React from "react";
import { PostTemplate } from "./template/PostTemplate";

const Blogs = ({ item }) => {
    const data = {
        image: item.feature_img.src,
        title: item.title,
        description: item.content,
        updated_at: item.updated_at,
        url: `/blogs/${item.id}` ?? '#'
    };
    return (
        <PostTemplate props={data} />
    );
}

export default Blogs;